module.exports = __webpack_public_path__ + "assets/img/google-dialogflow.84f8529b.png";